import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { hasPermission } from '../../utils/permissions';
import { getDefaultRouteForRole } from '../../constants/accessControl';
import Icon from '../AppIcon';

const ProtectedRoute = ({ children, permission, permissions, requireAll = false }) => {
  const { user, userProfile, loading, profileLoading } = useAuth();
  const location = useLocation();

  if (loading || profileLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Icon name="Loader2" size={32} className="text-primary animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  const requiredPermissions = permission
    ? [permission]
    : Array.isArray(permissions)
      ? permissions
      : [];

  if (requiredPermissions.length) {
    const allowed = requireAll
      ? requiredPermissions.every((key) => hasPermission(userProfile, key))
      : requiredPermissions.some((key) => hasPermission(userProfile, key));

    if (!allowed) {
      const fallback = getDefaultRouteForRole(userProfile?.role) || '/admin-dashboard';
      return <Navigate to={fallback} replace state={{ accessDenied: true }} />;
    }
  }

  return children;
};

export default ProtectedRoute;
